import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PanelSettingEntity } from '../../domain/entities/PanelSettingEntity'
import type { PanelSettingAdminDto } from '@/backend/market'
export class PanelSettingModel extends PanelSettingEntity {
  constructor(dataDto: PanelSettingAdminDto) {
    super()
    mapEntityProperties<PanelSettingEntity>(this, dataDto)
  }
}
